import { create } from 'zustand';
import { ChatSession } from '../../features/chat/types/ChatSession';
import useGetChatSessions from '../../features/chat/hooks/useGetChatSessions';
import { useEffect } from 'react';
import { useAuthStore } from './useAuthStore';

export const ChatNotificationsInitializer = () => {
  const { auth } = useAuthStore();
  const { refetch } = useGetChatSessions();

  useEffect(() => {
    if (auth.userId) {
      refetch();
    }
  }, [auth.userId, refetch]);

  return null; // This is a utility component that doesn't render anything
};

interface ChatNotificationsState {
  unreadSessions: ChatSession[];
  setUnreadSessions: (sessions: ChatSession[]) => void;
  clearUnreadSessions: () => void;
}

export const useChatNotificationsStore = create<ChatNotificationsState>(
  (set) => ({
    unreadSessions: [],
    setUnreadSessions: (sessions) => set({ unreadSessions: sessions }),
    clearUnreadSessions: () => set({ unreadSessions: [] }),
  }),
);
